import React from "react";
import "./loading.css";

function Loading() {
  return (
    <div className="d-flex align-items-center justify-content-center vh-100">
      <div className="loadingio-spinner-spin-gv8l7k3szza">
        <div className="ldio-56rk87u4npg">
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
          <div>
            <div></div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Loading;
